import { useEffect, useRef } from "react";
import { track } from "./analytics";

// Fires a `feature_view` event exactly once when the section scrolls into view.
export function useFeatureView(featureName) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          track("feature_view", { feature: featureName });
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [featureName]);
  return ref;
}
